<template>

    <div class="panel">
        <div v-if="canClose" class="panel-header">
            <span>{{ title }}</span>
            <v-close @click.native="close" />
        </div>
        <div class="panel-body">
            <slot></slot>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .panel {
        @include scrollbar();
        border-left: 1px solid $color-rule;
        display: flex;
        flex-direction: column;
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
        .panel-header {
            @include font-medium(13px);
            align-items: center;
            background: #fff;
            border-bottom: 1px solid $color-rule;
            display: flex;
            flex-shrink: 0;
            justify-content: space-between;
            padding: 15px;
            position: relative;
        }
        .panel-body {
            flex-grow: 1;
            overflow-y: auto;
        }
    }

</style>

<script>

export default {

    props: {
        title: {
            type: String,
        },
        canClose: {
            type: Boolean,
            default: true,
        },
    },

    methods: {

        close() {
            this.$store.commit('builder/setSelectedPanel', null);
        },

    },

}

</script>